import { render, staticRenderFns } from "./suitquery.vue?vue&type=template&id=d90b3510&scoped=true&"
import script from "@/service/suitqueryservice.js?vue&type=script&charset=utf-8&lang=js&"
export * from "@/service/suitqueryservice.js?vue&type=script&charset=utf-8&lang=js&"
import style0 from "./suitquery.vue?vue&type=style&index=0&id=d90b3510&scoped=true&lang=scss&"
import style1 from "./suitquery.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d90b3510",
  null
  
)

export default component.exports